import { SIZE_50 } from '@/lib/gridElements/size';

import { ChoroplethMapChart } from '@/components/composite/Charts/ChoroplethMapChart';

export const countriesDistributionConfig = {
    height: 300,
    name: {
        name: 'chart.tiktok.countries_distribution_country',
        value: 'chart.tiktok.countries_distribution_value',
        country: 'chart.tiktok.countries_distribution_country',
        percentage: 'percentage'
    },
    tooltip: 'chart.tiktok.countries_distribution_tooltip',
    noLegend: true,
    datePickerDoesNotApply: true,
    id: 'countries_distribution',
    size: SIZE_50,
    type: 'chart',
    element: ChoroplethMapChart,
    defaultFilter: 'global',
    defaultTableSorting: [{ id: 'value', desc: true }],
    filters: {
        global: {
            title: 'chart.tiktok.countries_distribution_followers',
            menu: 'chart.tiktok.countries_distribution_filter_followers'
        },
        reach: {
            title: 'chart.tiktok.countries_distribution_reach',
            menu: 'chart.tiktok.countries_distribution_filter_reach'
        }
    }
};
